/**
 * @class Node
 *
 * Represents node in tree list.
 */
export default class Node {
    /**
     * @param id {Number}
     * @param name {String}
     * @param parentId {Number}
     * @param nodes {Array}
     * @param items {Array}
     */
    constructor(id, name, parentId, nodes, items) {
        this._id = id;
        this._name = name;
        this._parentId = parentId;
        this._nodes = nodes;
        this._items = items;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    get parentId() {
        return this._parentId;
    }

    get nodes() {
        return this._nodes;
    }

    set nodes(nodes) {
        this._nodes = nodes;
    }

    get items() {
        return this._items;
    }

    set items(items) {
        this._items = items;
    }

    addItem = (item) => {
        this._items.push(item);
    };
}
